module.exports = __webpack_public_path__ + "static/wl-icons-dark-9135e6733284a16e4616949aabb95aea.png";